export default "https://legacy.eskolare-development.com/images/item.png";